import { Component, Input } from '@angular/core';
import { Opportunity } from 'src/app/modules/platform/components/opportunities/model/opportunities.model';

@Component({
  selector: 'app-crowd-card',
  templateUrl: './crowd-card.component.html',
  styleUrls: ['./crowd-card.component.scss'],
})
export class CrowdCardComponent {
  @Input() project: Opportunity | undefined;

  formmatedDate(date: string) {
    const fecha = new Date(date);

    const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    const mes = meses[fecha.getMonth()];
   
    const año = fecha.getFullYear();

    // Obtenemos los últimos dos dígitos del año
    const ultimoDosDigitosAño = String(año).slice(-2);

    const fechaFormateada = `${mes}/${ultimoDosDigitosAño}`;

    return fechaFormateada;
  }

  roundNumber(num: number | undefined): number | '' {
    return num ? Math.round(num) : 0;
  }

  calcPercentage(tokenBrought: number, totalTokens: number): number {
    const percentage = (tokenBrought / totalTokens) * 100;
    const roundedPercentage = Math.round(percentage);
    return roundedPercentage;
  }
}
